import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { TimetableRequest } from "../../../api/Timetable";

/**
 * Returns the appropriate week title for a specific
 * week offset
 * @param {Int} week
 */
const currentWeekTitle = week => {
  const request = new TimetableRequest(null, null);
  const date = request.setWeek(week);

  return date.toLocaleDateString();
};

/**
 * TimetableTitle: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Title displayed above the timetable, which automatically
 * updates based on the selected week
 *
 * @param {*} props
 */
const TimetableTitle = props => (
  <h3>
    <FormattedMessage
      id="agenda.timetable.title.week"
      description="Timetable title in week view"
      values={{ mondayDate: currentWeekTitle(props.currentWeek) }}
    />
  </h3>
);

TimetableTitle.propTypes = {
  /**
   * currentWeek: Int
   * Number of weeks the selected week is offset from the current week
   */
  currentWeek: PropTypes.number.isRequired
};

export default TimetableTitle;



// WEBPACK FOOTER //
// ./src/modules/agenda/timetable/TimetableTitle.js